import { render, staticRenderFns } from "./FarmItem.vue?vue&type=template&id=1c4adcc0&scoped=true&lang=pug"
import script from "./FarmItem.vue?vue&type=script&lang=js"
export * from "./FarmItem.vue?vue&type=script&lang=js"
import style0 from "./FarmItem.vue?vue&type=style&index=0&id=1c4adcc0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4adcc0",
  null
  
)

export default component.exports